import React from 'react';
import { Link } from 'react-router-dom';
import { SharedNavbar } from '../components/SharedNavbar';
import { Footer } from '../components/Footer';
import { FadeIn } from '../components/FadeIn';
import { Sparkles, BookOpen, Heart, ArrowRight, Star, Leaf, MessageCircle, Gift, Clock } from 'lucide-react';
export function AhaAcademyPage() {
  const whatsappLink = 'https://wa.me/40771946011?text=Buna%20Mihaela.%0A%0AAs%20dori%20mai%20multe%20detalii%20despre%20sau%20despre%20programele%20tale%20online%2C%20sau%20despre%20sesiunile%20de%20Coaching%201%20la%201.';
  const products = [{
    tag: 'RECOMANDAT',
    badge: {
      icon: Star,
      label: 'Recomandat',
      highlight: true
    },
    kind: {
      icon: Leaf,
      label: 'Program de Transformare'
    },
    title: 'ANIMA Recode',
    subtitle: 'Călătoria ta către încredere autentică',
    description: 'Program ghidat de 9 luni în care lucrezi cu mintea, emoțiile și sistemul tău familial. Cele 9 module + workshop-uri lunare + comunitate privată.',
    image: 'https://cdn.magicpatterns.com/uploads/vpA5XLsZA8NiouiGoUZh1w/anima_recode_hero.jpg',
    ctaLabel: 'Vreau ANIMA Recode',
    ctaLink: '/animarecode',
    featured: true
  }, {
    tag: 'ÎNCEPĂTORI',
    badge: null,
    kind: {
      icon: BookOpen,
      label: 'Mini-curs Online'
    },
    title: 'Cum îți gestionezi emoțiile copleșitoare',
    subtitle: 'Pentru că a simți nu înseamnă a te pierde',
    description: '5 audio-uri ghidate + workbook PDF de 13 pagini care te învață să îți reglezi emoțiile, pas cu pas, în mai puțin de o săptămână.',
    image: 'https://cdn.magicpatterns.com/uploads/34kB1rguyriUqrZ9ZF82yj/anima_healing_academy_hero.jpg',
    ctaLabel: 'Vreau Mini-cursul',
    ctaLink: '/aha',
    featured: false
  }, {
    tag: 'PERSONALIZAT',
    badge: null,
    kind: {
      icon: Heart,
      label: 'Sesiuni Individuale'
    },
    title: 'Coaching 1 la 1',
    subtitle: 'Spațiul tău sigur pentru claritate și vindecare',
    description: 'Sesiuni individuale personalizate în care folosim NLP, Constelații Familiale și Coaching pentru a debloca potențialul tău și a vindeca rănile trecutului.',
    image: 'https://cdn.magicpatterns.com/uploads/4jJnQjtiPNiubtH5dxzgfZ/coaching_1la1_hero.jpg',
    ctaLabel: 'Vreau Sesiune 1 la 1',
    ctaLink: '/sesiune1la1',
    featured: false
  }];
  return <>
      <SharedNavbar data-id="element-830" />
      <main className="flex-grow" data-id="element-831">
        {/* HERO */}
        <section className="relative pt-32 pb-12 md:pt-40 md:pb-16 bg-ivory overflow-hidden" data-id="element-832">
          <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-833">
            <div className="absolute top-[-10%] right-[-5%] w-[50%] h-[50%] bg-gold/10 rounded-full blur-3xl" data-id="element-834"></div>
            <div className="absolute bottom-[-10%] left-[-5%] w-[40%] h-[40%] bg-forest/5 rounded-full blur-3xl" data-id="element-835"></div>
          </div>

          <div className="max-w-[900px] mx-auto px-6 md:px-8 text-center relative z-10" data-id="element-836">
            <FadeIn data-id="element-837">
              <div className="inline-flex items-center gap-2 border border-gold/40 rounded-full px-5 py-2 mb-6 bg-white/50 backdrop-blur-sm" data-id="element-838">
                <Sparkles className="w-4 h-4 text-gold-dark" data-id="element-839" />
                <span className="font-display text-sm font-medium tracking-wider text-forest uppercase" data-id="element-840">
                  Cursuri & Programe
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-841">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium text-forest mb-6 leading-tight" data-id="element-842">
                Alege parcursul tău
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-843">
              <p className="text-[19px] text-charcoal/80 leading-relaxed max-w-[680px] mx-auto" data-id="element-844">
                De la primul pas în reglarea emoțiilor până la transformarea
                profundă pe 9 luni. Toate cursurile, programele și sesiunile
                mele, într-un singur loc.
              </p>
            </FadeIn>
          </div>
        </section>

        {/* PRODUCTS GRID */}
        <section className="py-12 md:py-20 bg-white" data-id="element-845">
          <div className="max-w-[1200px] mx-auto px-6 md:px-8" data-id="element-846">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8" data-id="element-847">
              {products.map((p, i) => {
              const KindIcon = p.kind.icon;
              return <FadeIn key={i} delay={i * 0.1} className="h-full" data-id="element-848">
                    <div className={`group relative h-full flex flex-col rounded-[28px] overflow-hidden border-2 transition-all duration-500 hover:-translate-y-2 hover:shadow-2xl ${p.featured ? 'border-gold/50 shadow-xl bg-ivory' : 'border-forest/15 bg-ivory hover:border-gold/40'}`} data-id="element-849">
                      {/* Image - 16:9 horizontal */}
                      <div className="relative aspect-video overflow-hidden" data-id="element-850">
                        <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" data-id="element-851" />
                        {/* Recommended badge */}
                        {p.badge && <div className="absolute top-4 right-4" data-id="element-852">
                            <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-gold text-forest font-display text-[11px] font-bold tracking-widest uppercase shadow-md" data-id="element-853">
                              <Star className="w-3.5 h-3.5 fill-forest" data-id="element-854" />
                              {p.badge.label}
                            </div>
                          </div>}
                        {/* Kind badge bottom-left */}
                        <div className="absolute bottom-4 left-4" data-id="element-855">
                          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-forest/90 text-ivory font-display text-[12px] font-medium backdrop-blur-sm" data-id="element-856">
                            <KindIcon className="w-3.5 h-3.5" data-id="element-857" />
                            {p.kind.label}
                          </div>
                        </div>
                      </div>

                      {/* Content */}
                      <div className="p-7 md:p-8 flex flex-col flex-grow" data-id="element-858">
                        <span className="font-display text-[11px] font-semibold tracking-[0.2em] text-gold-dark uppercase mb-3" data-id="element-859">
                          {p.tag}
                        </span>

                        <h3 className="text-2xl md:text-[26px] font-serif font-medium text-forest mb-2 leading-tight" data-id="element-860">
                          {p.title}
                        </h3>

                        <p className="font-serif italic text-charcoal/70 text-[16px] mb-5 pb-5 border-b border-forest/10 leading-snug" data-id="element-861">
                          {p.subtitle}
                        </p>

                        <p className="text-[18px] text-charcoal/75 leading-relaxed mb-7 flex-grow" data-id="element-862">
                          {p.description}
                        </p>

                        <Link to={p.ctaLink} className="mt-auto inline-flex items-center justify-center gap-2 px-6 py-3.5 rounded-full font-display font-medium text-[15px] transition-all duration-300 no-underline bg-forest text-ivory hover:bg-forest-dark" data-id="element-863">
                          {p.ctaLabel}
                          <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-864" />
                        </Link>
                      </div>
                    </div>
                  </FadeIn>;
            })}
            </div>
          </div>
        </section>

        {/* "Nu știi ce să alegi?" CTA */}
        <section className="py-16 md:py-24 bg-ivory" data-id="element-865">
          <div className="max-w-[1100px] mx-auto px-6 md:px-8" data-id="element-866">
            <FadeIn data-id="element-867">
              <div className="relative rounded-[36px] overflow-hidden bg-forest text-ivory p-10 md:p-16 lg:p-20 text-center shadow-2xl" data-id="element-868">
                {/* Decorative glow */}
                <div className="absolute -top-20 -right-20 w-72 h-72 bg-gold/15 rounded-full blur-3xl pointer-events-none" data-id="element-869"></div>
                <div className="absolute -bottom-20 -left-20 w-72 h-72 bg-gold/10 rounded-full blur-3xl pointer-events-none" data-id="element-870"></div>

                <div className="relative z-10" data-id="element-871">
                  {/* Gift icon */}
                  <div className="inline-flex w-16 h-16 rounded-2xl bg-gold/15 border border-gold/30 items-center justify-center mb-6" data-id="element-872">
                    <Gift className="w-8 h-8 text-gold" data-id="element-873" />
                  </div>

                  {/* Time tag */}
                  <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-ivory/10 border border-gold/30 mb-6" data-id="element-874">
                    <Clock className="w-3.5 h-3.5 text-gold" data-id="element-875" />
                    <span className="font-display text-[11px] font-semibold tracking-[0.25em] text-gold uppercase" data-id="element-876">
                      30 de minute · Cadou
                    </span>
                  </div>

                  <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-medium text-ivory mb-5 leading-tight" data-id="element-877">
                    Nu știi ce să alegi?
                  </h2>

                  <p className="text-[19px] text-ivory/85 leading-relaxed max-w-[640px] mx-auto mb-10" data-id="element-878">
                    Rezervă o sesiune cadou de 30 de minute cu mine pe WhatsApp.
                    Vorbim despre unde ești acum, ce îți dorești și ce program
                    sau curs ți se potrivește cel mai bine. Fără presiune, fără
                    vânzare. Doar claritate.
                  </p>

                  <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center gap-3 px-9 py-4 rounded-full bg-gold text-forest font-display font-semibold text-[17px] hover:bg-gold-dark transition-all duration-300 shadow-xl hover:-translate-y-1 no-underline" data-id="element-879">
                    <MessageCircle className="w-5 h-5" data-id="element-880" />
                    Rezervă Sesiunea pe WhatsApp
                    <ArrowRight className="w-5 h-5" data-id="element-881" />
                  </a>
                </div>
              </div>
            </FadeIn>
          </div>
        </section>
      </main>
      <Footer data-id="element-882" />
    </>;
}